import React, { memo } from 'react';

const Card = memo(({ title, children, className = '' }) => {
  return (
    <div className={`card ${className}`}>
      {title && <h3 className="text-xl font-semibold mb-4">{title}</h3>}
      {children}
    </div>
  );
});

Card.displayName = 'Card';

export default Card;
